import type { FilterModule } from "../index";
import { GlobalPresenceFilter } from "./GlobalPresenceFilter";
import { getChips, getCount } from "./chips";
import { fromCompanyFilters, toCompanyFilters } from "./mapper";
import { defaultGlobalPresenceSlice, type GlobalPresenceSlice } from "./slice";

export type { GlobalPresenceSlice } from "./slice";
export { defaultGlobalPresenceSlice } from "./slice";

export const globalPresenceModule: FilterModule<GlobalPresenceSlice> = {
  key: "globalPresence",
  defaultSlice: defaultGlobalPresenceSlice,
  Component: GlobalPresenceFilter,
  getChips,
  getCount,
  toCompanyFilters,
  fromCompanyFilters,
};
